import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class CompanyProxy extends BaseProxy implements ProxyMethods {
  public endpoint = 'companies'

  public async authAsCompany(id: string, userId?: string | null) {
    return this.submit('post', `${this.endpoint}/${id}/auth`, userId ? { userId } : {})
  }

  public async me() {
    return this.submit('get', `${this.endpoint}/me`)
  }
}
